import { render, staticRenderFns } from "./Scoring2b.vue?vue&type=template&id=d74d1cc0&"
import script from "./Scoring2b.vue?vue&type=script&lang=js&"
export * from "./Scoring2b.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports